import { ActionTypes, AutomatedEmailsAction, AutomatedRuleRecord } from './actions';

export interface AutomatedEmailsState {
  rules: AutomatedRuleRecord[];
  totalElements: number;
  loading: boolean;
  saving: boolean;
  error: string | null;
}

const initialState: AutomatedEmailsState = {
  rules: [],
  totalElements: 0,
  loading: false,
  saving: false,
  error: null,
};

const automatedEmailsReducer = (
  state = initialState,
  action: AutomatedEmailsAction,
): AutomatedEmailsState => {
  switch (action.type) {
    case ActionTypes.FETCH_RULES_REQUEST:
      return { ...state, loading: true, error: null };

    case ActionTypes.FETCH_RULES_SUCCESS:
      return {
        ...state,
        loading: false,
        rules: action.payload.rules,
        totalElements: action.payload.totalElements,
      };

    case ActionTypes.FETCH_RULES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case ActionTypes.UPDATE_RULE_REQUEST:
    case ActionTypes.TOGGLE_STATUS_REQUEST:
      return { ...state, saving: true, error: null };

    case ActionTypes.UPDATE_RULE_SUCCESS:
    case ActionTypes.TOGGLE_STATUS_SUCCESS: {
      const updated = action.payload;
      return {
        ...state,
        saving: false,
        rules: state.rules.map(r => (r.id === updated.id ? updated : r)),
      };
    }

    case ActionTypes.UPDATE_RULE_FAILURE:
    case ActionTypes.TOGGLE_STATUS_FAILURE:
      return { ...state, saving: false, error: action.payload };

    default:
      return state;
  }
};

export default automatedEmailsReducer;
